<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>{{ modalTitle }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <c-input type="image" container-class="mb-3" placeholder="Sélectionner un logo"
                 default="DEFAULT_OPERATOR_ICON" v-model="logo" :state="logoState">
          Veuillez charger un logo
        </c-input>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input container-class="mb-3" label="Nom de la banque" placeholder="Ex: My-CoolPay" v-model="name"
                     :state="nameState">
              Veuillez saisir un nom
            </c-input>
            <c-input container-class="mb-3" label="Slug" placeholder="Ex: MCP" v-model="slug" :state="slugState">
              Veuillez saisir un slug
            </c-input>
            <c-input container-class="mb-3" label="Code" placeholder="Ex: MCP" v-model="code" :state="codeState">
              Veuillez saisir un code
            </c-input>
            <c-input type="textarea" container-class="mb-3" label="Description" placeholder="Entrez une description..."
                     v-model="description"/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Virements - Frais fixes"
                     placeholder="Ex: 500" v-model="transfer_fees" :state="transfer_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Virements - Commissions"
                     placeholder="Ex: 3" v-model="transfer_commission_rate" :state="transfer_commission_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
          </d-col>
          <d-col class="ml-2">
            <c-input type="price" currency="XAF" container-class="mb-3" label="Recharges - Frais fixes"
                     placeholder="Ex: 500" v-model="top_up_fees" :state="top_up_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Recharges - Commissions"
                     placeholder="Ex: 3" v-model="top_up_commission_rate" :state="top_up_commission_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Virements - Frais fixes de la banque"
                     placeholder="Ex: 500" v-model="bank_fees" :state="bank_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Virements - Commissions de la banque"
                     placeholder="Ex: 3" v-model="bank_transfer_commission_rate" :state="bank_transfer_commission_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Recharges - Frais fixes de la banque"
                     placeholder="Ex: 500" v-model="bank_top_up_fees" :state="bank_top_up_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Recharges - Commissions de la banque"
                     placeholder="Ex: 3" v-model="bank_top_up_commission_rate" :state="bank_top_up_commission_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4">
        <d-input-group class="justify-content-center">
          <d-button class="inline-btn" @click="modalVisible = true">
            <i class="fa fa-plus mr-1"></i> Ajouter une banque
          </d-button>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="data" :fields="fields" :actions="actions" :per-page="50">
          <p class="text-center" slot="empty">Aucune banque trouvée.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, asset, formatAmount, Regex, Toast} from "../../helpers/index"

export default {
  title: "Paramètres des banques",
  data() {
    return {
      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'logo', label: 'Logo', sortable: true},
        {key: 'name', label: 'Nom', sortable: true},
        {key: 'slug', label: 'Slug', sortable: true},
        {key: 'code', label: 'Code', sortable: true},
        {key: 'transfer_commission_rate', label: '% Vir.', sortable: true},
        {key: 'transfer_fees_pretty', label: 'Frais Vir.', sortable: true},
        {key: 'top_up_commission_rate', label: '% Rech', sortable: true},
        {key: 'top_up_fees_pretty', label: 'Frais Rech.', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-cog', title: "Paramètres de la banque", handler: this.onItemSelect},
        {type: 'outline-danger', icon: 'fa fa-times', title: "Supprimer la banque", handler: this.onItemRemove},
      ],

      modalVisible: false,

      selectedItem: null,

      logo: null,
      name: '',
      slug: '',
      description: '',
      code: '',
      transfer_fees: '',
      transfer_commission_rate: '',
      bank_fees: '',
      bank_transfer_commission_rate: '',
      top_up_fees: '',
      top_up_commission_rate: '',
      bank_top_up_fees: '',
      bank_top_up_commission_rate: '',

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    itemSelected() {
      return !!this.selectedItem
    },
    modalTitle() {
      return this.itemSelected ? "Paramétrage d'une banque" : "Ajout d'une banque"
    },
    logoState() {
      return true
      // return !this.submitted || this.logo
    },
    nameState() {
      return !this.submitted || Regex.isNotBlank(this.name)
    },
    slugState() {
      return !this.submitted || Regex.isNotBlank(this.slug)
    },
    codeState() {
      return !this.submitted || Regex.isNotBlank(this.code)
    },
    transfer_feesState() {
      return !this.submitted || Regex.isPositiveInteger(this.transfer_fees)
    },
    transfer_commission_rateState() {
      return !this.submitted || Regex.isValidRate(this.transfer_commission_rate)
    },
    bank_feesState() {
      return !this.submitted || Regex.isPositiveInteger(this.bank_fees)
    },
    bank_transfer_commission_rateState() {
      return !this.submitted || Regex.isValidRate(this.bank_transfer_commission_rate)
    },
    top_up_feesState() {
      return !this.submitted || Regex.isPositiveInteger(this.top_up_fees)
    },
    top_up_commission_rateState() {
      return !this.submitted || Regex.isValidRate(this.top_up_commission_rate)
    },
    bank_top_up_feesState() {
      return !this.submitted || Regex.isPositiveInteger(this.bank_top_up_fees)
    },
    bank_top_up_commission_rateState() {
      return !this.submitted || Regex.isValidRate(this.bank_top_up_commission_rate)
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/bank/list')
      .then(res => {
        this.data = res.data.banks.map(this.mapItem)
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        logo: asset(item.logo),
        transfer_fees_pretty: formatAmount(item.transfer_fees),
        top_up_fees_pretty: formatAmount(item.top_up_fees),
      }
    },
    onItemSelect(item, noModal) {
      this.selectedItem = item
      this.logo = item.logo
      this.name = item.name
      this.slug = item.slug
      this.description = item.description
      this.code = item.code
      this.transfer_fees = item.transfer_fees
      this.transfer_commission_rate = item.transfer_commission_rate
      this.bank_fees = item.bank_fees
      this.bank_transfer_commission_rate = item.bank_transfer_commission_rate
      this.top_up_fees = item.top_up_fees
      this.top_up_commission_rate = item.top_up_commission_rate
      this.bank_top_up_fees = item.bank_top_up_fees
      this.bank_top_up_commission_rate = item.bank_top_up_commission_rate
      if (!noModal)
        this.modalVisible = true
    },
    clearFields() {
      this.logo = null
      this.name = ''
      this.slug = ''
      this.description = ''
      this.code = ''
      this.transfer_fees = ''
      this.transfer_commission_rate = ''
      this.bank_fees = ''
      this.bank_transfer_commission_rate = ''
      this.top_up_fees = ''
      this.top_up_commission_rate = ''
      this.bank_top_up_fees = ''
      this.bank_top_up_commission_rate = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.error = null
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return this.logoState && this.nameState && this.slugState && this.codeState
        && this.transfer_feesState && this.transfer_commission_rateState
        && this.bank_feesState && this.bank_transfer_commission_rateState
        && this.top_up_feesState && this.top_up_commission_rateState
        && this.bank_top_up_feesState && this.bank_top_up_commission_rateState
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      const route = this.itemSelected ? '/bank/update' : '/bank/create'
      const extraData = this.itemSelected ? {bank_id: this.selectedItem.id} : {}

      this.fetchingFormSubmit = true
      Api.postFormData(route, {
        logo: this.logo,
        name: this.name,
        slug: this.slug,
        description: this.description,
        code: this.code,
        transfer_fees: this.transfer_fees,
        transfer_commission_rate: this.transfer_commission_rate,
        bank_fees: this.bank_fees,
        bank_transfer_commission_rate: this.bank_transfer_commission_rate,
        top_up_fees: this.top_up_fees,
        top_up_commission_rate: this.top_up_commission_rate,
        bank_top_up_fees: this.bank_top_up_fees,
        bank_top_up_commission_rate: this.bank_top_up_commission_rate,
        ...extraData
      })
        .then(res => {
          const bank = this.mapItem(res.data.bank)
          const operation = this.itemSelected ? "mise à jour" : "créée"

          if (this.itemSelected)
            this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, bank)
          else
            this.data.push(bank)

          this.onModalClose()

          Toast.success(`La banque "${bank.name}" a été ${operation} avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onItemRemove(item) {
      const ans = prompt(`Veuillez saisir SUPPRIMER pour supprimer la banque "${item.name}".`)
      if (ans !== 'SUPPRIMER') return

      Toast.loading("Suppression de la banque...")
      Api.postFormData('/bank/delete', {bank_id: item.id})
        .then(() => {
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`La banque "${item.name}" a été supprimée avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    },
  }
}
</script>

<style scoped>
.table td {
  white-space: normal !important;
  padding: 0 1rem !important;
}
</style>
